<template lang="pug">
#modal-editar-lote-de-producao
    el-dialog(
        width='600px',
        title='Editar',
        :visible.sync='mostrar',
        :close-on-click-modal='false',
        :before-close='fechar'
    )
        el-form(label-position='top')
            el-row(:gutter="20")
                el-col(:span="12")
                    el-form-item
                        template(slot='label')
                            span Número do Lote de controle

                        el-input(v-model='numeroLoteControle', placeholder='Número do Lote de controle', type='number')
                el-col(:span="12")
                    el-form-item
                        template(slot='label')
                            span Número do Lote de produção

                        el-input(v-model='numeroLoteProducao', placeholder='Número do Lote de produção')
            
            el-row(:gutter="20")
                el-col(:span="12")
                    el-form-item
                        template(slot='label')
                            span Material

                        el-input(v-model='material', maxlength='200', placeholder='Código do Talhão')
                
                el-col(:span="12")
                    el-form-item
                        template(slot='label')
                            span Quantidade do Lote real

                        el-input(v-model='quantidadeLoteReal', maxlength='200', placeholder='Quantidade do Lote real', type='number')
            
            el-row(:gutter="20")
                el-col(:span="12")
                    el-form-item
                        template(slot='label')
                            span Data de entrada na usina

                        el-date-picker(
                            v-model='dataEntradaUsina',
                            placement='bottom-start',
                            type='date',
                            placeholder='Data de entrada na usina',
                            format='dd/MM/yyyy'
                        )

        footer.espaco(slot='footer')
            BaseButton(type='default', @click='fechar') Cancelar

            BaseButton(
                type='primary',
                @click='salvar'
                :disabled='!checkCamposValidos()',
            ) Salvar

</template>

<script>
import RastreabilidadeLoteDeProducaoService from '@/services/RastreabilidadeLoteDeProducaoService';
import BaseButton from '@/components/vegaComponents/BaseButton.vue';

export default {
    name: 'ModalEditarLoteDeProducao',
    components: {
        BaseButton
    },
    emits: ['atualizarDados'],
    props: {
        mostrar: {
            type: Boolean,
            required: true
        },

        editar: {
            type: Boolean,
            required: false,
            default: false
        },

        dados: {
            type: Object,
            required: false,
            default: null
        }
    },

    data() {
        return {
            id: '',
            numeroLoteControle: '',
            numeroLoteProducao: '',
            material: '',
            quantidadeLoteReal: '',
            dataEntradaUsina: ''
        };
    },

    watch: {
        mostrar() {
            if (this.dados) {
                this.id = this.dados.id;
                this.numeroLoteControle = this.dados.numeroLoteControle;
                this.numeroLoteProducao = this.dados.numeroLoteProducao;
                this.material = this.dados.material;
                this.quantidadeLoteReal = this.dados.quantidadeLoteReal;

                let dataSplit = this.dados.dataEntradaUsina.split('/');
                let padraoDatePicker = `${dataSplit[1]}/${dataSplit[0]}/${dataSplit[2]}`;

                this.dataEntradaUsina = new Date(padraoDatePicker);
            }
        }
    },

    methods: {
        fechar() {
            this.id = '';
            this.numeroLoteControle = '';
            this.numeroLoteProducao = '';
            this.material = '';
            this.quantidadeLoteReal = '';
            this.dataEntradaUsina = '';

            this.$emit('fechar');
        },

        atualizarListaRepresentantes() {
            this.$emit('atualizarListaRepresentantes');
        },

        checkCamposValidos() {
            if (
                this.numeroLoteControle !== '' &
                this.numeroLoteProducao !== '' &
                this.material !== '' &
                this.quantidadeLoteReal !== '' &
                this.dataEntradaUsina !== ''
                ) {
                    return true;
                }

            return false;
        },

        async salvar() {
            try {
                await RastreabilidadeLoteDeProducaoService.editarLoteDeProducao({
                    id: this.dados.id,
                    numeroLoteControle: this.numeroLoteControle,
                    numeroLoteProducao: this.numeroLoteProducao,
                    material: this.material,
                    quantidadeLoteReal: this.quantidadeLoteReal,
                    dataEntradaUsina: this.dataEntradaUsina.toLocaleDateString('pt-BR')
                });

                this.fechar();
                this.$emit('atualizarDados');

                this.$notify.success({
                    message: 'Lote de Produção editado com sucesso'
                });
            } catch (e) {
                this.$notify.error({
                    message: e.response.data.message
                });
            }
        }
    }
};
</script>

<style lang="scss">
footer {
    display: flex;
    justify-content: space-between;
}

.invalido {
    color: var(--danger);
}

.espaco {
    display: flex;
}

.el-date-editor.el-input {
    width: 100%;
}
</style>
